if (!customElements.get('product-inventory')) {
    class ProductInventory extends HTMLElement {
        constructor() {
            super();
            window.initLazyScript(this, this.initLazySection.bind(this));
        }

        initLazySection() {
            this.inventoryNotice = this.querySelector('.js-inventory-notice');
            this.urgencyMessage = this.querySelector('.js-inventory-urgency');
            this.indicatorBar = this.querySelector('.js-inventory-indicator');
         //   this.utStockCount = this.querySelector('.inventory-count')
            this.variantInventory = this.getVariantInventory();
            this.isDropship = this.getVariantStockType();
         //   this.stockCode = this.getVariantStockCode();
         //   this.utStock = this.getUtahStock();


            // Bind to on:variant:change event for this product
            const variantPicker = this.closest('.product-info').querySelector('variant-picker');
            if (variantPicker) {
                variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
            }

            // Init
            this.updateInventory(
                parseInt(this.dataset.inventoryQuantity, 10),
                this.dataset.variantAvailable === 'true',
                this.dataset.inventoryPolicy,
                this.isDropship,
              //  this.stockCode,
              //  this.utStock
            );

            // const element = document.getElementById('inventory_status_text');
            // element.style.setProperty('--before-opacity', '1');

            //console.log("stock code: " + this.stockCode);
            //console.log("Dropship Option: " + this.isDropship);
        }

        /**
         * Gets the inventory data for all product variants
         * @returns {?object}
         */
        getVariantInventory() {
            const dataEl = this.querySelector('[type="application/json"]');
            return this.variantInventory || JSON.parse(dataEl.textContent);
        }

        /**
         * Gets the stock type data for all product variants
         * @returns {?object}
         */
        getVariantStockType() {
            const dataEl = this.querySelector('[type="application/json"]');
            return JSON.parse(dataEl.textContent)[0].is_dropship;
        }

        /**
         * Gets the stock type data for all product variants
         * @returns {?object}
         */

        /*
        getUtahStock() {
            const dataEl = this.querySelector('[type="application/json"]');
            return JSON.parse(dataEl.textContent)[0].ut_stock;
        } 
        */

        /**
         * Gets the stock type data for all product variants
         * @returns {?object}
         */

        /*
        getVariantStockCode() {
            const dataEl = this.querySelector('[type="application/json"]');
            return JSON.parse(dataEl.textContent)[0].stock_code;
        }
        */

        /**
         * Handles a 'change' event on the variant picker element
         * @param {object} evt - Event object
         */
        handleVariantChange(evt) {
            if (evt.detail.variant) {
                const inventory = this.variantInventory.filter(
                    (variant) => variant.id === evt.detail.variant.id
                )[0];
                this.updateInventory(
                    inventory.inventory_quantity,
                    inventory.available,
                    inventory.inventory_policy,
                    inventory.is_dropship,
                    //inventory.stock_code,
                    //inventory.ut_stock
                );
            } else {
                this.updateInventory(0, false);
                this.hidden = true;
            }
        }

        /**
         *
         * Updates the inventory notice
         * @param {number} count - the inventory quantity available
         * @param {boolean} available - whether current variant is available
         * @param {string} inventoryPolicy - whether product continues selling when out of stock
         * @param {string} isDropship - whether product is dropship only
         * @param {string} stockCode - stock code: IS, DS, BO
         */
        updateInventory(count, available, inventoryPolicy, isDropship, stockCode) {
            let inventoryLevel;
            //let ut_stock;
            //this.ut_stock = ut_stock;

            if (count <= 0) {
                if (isDropship === 'T') {
                    inventoryLevel = 'factory_direct';
                } else if (inventoryPolicy === 'continue') {
                    inventoryLevel = 'backordered';
                } else {
                    inventoryLevel = 'none';
                }
            } else if (count > 0)  {
                inventoryLevel = 'normal';
            } else {
                inventoryLevel = 'none';
            }


            // console.log(inventoryLevel);
            // console.log(stockCode);

            /* else {
                                if (count <= 0) {
                                    if (isDropship === 'T') {
                                        inventoryLevel = 'factory_direct';
                                    } else if (inventoryPolicy === 'continue') {
                                        inventoryLevel = 'backordered';
                                    } else {
                                        inventoryLevel = 'none';
                                    }
                                }
                                 else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
                                                       inventoryLevel = 'very_low';
                                                   } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
                                                       inventoryLevel = 'low';
                                                   } 
                                else {
                                    inventoryLevel = 'none';
                                                }
                                   
            } */

            if (this.dataset.showNotice === 'always') {

                this.hidden = false;

                // Set the inventory level data attribute
                this.setAttribute('data-inventory-level', inventoryLevel);

                // Update the stock count if applicable
               /* 
               if (ut_stock != '') {
                    this.hidden = false;
                    if (ut_stock == 0 || ut_stock == '0') {
                        inventoryLevel = 'none';
                        this.inventoryNotice.innerText = '';
                    }
                    this.utStockCount.innerHTML = "<span>• Quantity Available: " + ut_stock + '</span> ';
                }
                */

                //console.log("Inventory Level: " + inventoryLevel + "ut:" + ut_stock);
                // Determine whether to show the count or not
                if (inventoryLevel === 'backordered') {
                    this.inventoryNotice.innerText = 'Restocking Soon – Order Today';
                } else if (inventoryLevel === 'factory_direct') {
                    this.inventoryNotice.innerText = 'Factory Direct Shipping';
                } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
                    this.inventoryNotice.innerText = '✓ In Stock';
                } else if (inventoryLevel === 'none') {
                    // Do nothing
                } else {
                    this.hidden = true;
                }

                /*
                                // Update urgency message if needed
                                if (this.urgencyMessage) {
                                    if (inventoryLevel === 'very_low') {
                                        this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
                                    } else if (inventoryLevel === 'low') {
                                        this.urgencyMessage.innerHTML = this.dataset.textLow;
                                    } else if (inventoryLevel === 'backordered') {
                                        this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
                                    } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
                                        this.urgencyMessage.innerHTML = this.dataset.textNormal;
                                    } else if (inventoryLevel === 'none') {
                                        this.urgencyMessage.innerHTML = '';
                                    }
                                }
                                    */

                // Update the bar indicator
                /* if (this.indicatorBar) {
                     this.indicatorBar.hidden = false;

                     let newWidth;
                     if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
                         newWidth = 100;
                     } else {
                         newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
                     }
                     this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
                 }*/
            } else {
                this.hidden = true;
            }
        }
    }

    customElements.define('product-inventory', ProductInventory);
}